import React, { useState } from 'react';
import { LanguagesIcon, ReceiptTextIcon, SendIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { cn } from '../../utils/cn';
export function Composer({
  onSend,
  onOpenQuote,
  placeholder
}: {
  onSend: (body: string) => void;
  onOpenQuote?: () => void;
  placeholder?: string;
}) {
  const [body, setBody] = useState('');
  const {
    autoTranslate,
    setAutoTranslate
  } = useLocale();
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = body.trim();
    if (!text) return;
    onSend(text);
    setBody('');
  };
  return <form onSubmit={submit} className="space-y-2" data-id="element-132" data-mp="2sc1ahmdv2cau">
      <div className="flex items-end gap-2" data-id="element-133" data-mp="2wcl9kvhzvpzm">
        <label className="sr-only" htmlFor="composer" data-id="element-134" data-mp="2w9fn7o0r327l">
          Message
        </label>
        <textarea id="composer" value={body} rows={2} onChange={e => setBody(e.target.value)} onKeyDown={e => {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit(e);
      }} placeholder={placeholder ?? 'Write a message…'} className="min-h-[3rem] flex-1 resize-none rounded-xl border border-hairline bg-surface px-3.5 py-2.5 text-[15px] text-ink placeholder:text-ink-3 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25" data-id="element-135" data-mp="7jfyhn94w5ur" />
        {onOpenQuote && <Button type="button" variant="outline" size="md" onClick={onOpenQuote} data-id="element-136" data-mp="1gwt0o3u980i7">
            <ReceiptTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-137" data-mp="1c3go4s2unk5t" />
            <span className="hidden sm:inline" data-id="element-138" data-mp="1755d4e0tj3m0">Build quote</span>
          </Button>}
        <Button type="submit" variant="primary" size="md" disabled={!body.trim()} data-id="element-139" data-mp="126bxog1z12j7">
          <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="124hfh9i33oit" />
          <span className="sr-only" data-id="element-141" data-mp="y3feoo8ir4eq">Send</span>
        </Button>
      </div>
      <button type="button" onClick={() => setAutoTranslate(!autoTranslate)} className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[12px] transition-colors duration-150 ease-out', autoTranslate ? 'border-primary/40 bg-primary-soft text-primary' : 'border-hairline text-ink-3 hover:text-ink')} aria-pressed={autoTranslate} data-id="element-142" data-mp="t5dtnxrj8v0m">
        <LanguagesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-143" data-mp="ejq9iclbxqhr" />
        Auto-translate {autoTranslate ? 'on' : 'off'}
      </button>
    </form>;
}